module.exports = __webpack_public_path__ + "static/media/key-gray.8f40dea9.svg";